import React, { useState, useEffect } from 'react';
import PendingOrder from 'components/orders/PendingOrder'
/*
import ProductSearchBar from './../products/ProductSearchBar';
import ProductModal from '../products/ProductModal';
import FeaturedProducts from './../products/FeaturedProducts';
import ExpressOrder from '../orders/ExpressOrder';
import LastProducts from './../products/LastProducts';
*/
import { useSelector, useDispatch } from 'react-redux';
import { FaSearch } from "react-icons/fa"; // Import de l'icône de loupe
import { Link, useNavigate } from "react-router-dom";
import './home-main.css';
import { debug } from './../../utils';
const HomeMain = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const user = useSelector((state) => state.user);
  const [showProductModal, setShowProductModal] = useState(false);
  const navigate = useNavigate();
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
  };
  useEffect(() => {
    if (selectedProduct) {
      setShowProductModal(true);
    }
  }, [selectedProduct]);
  const handleCloseModal = () => {
    setSelectedProduct(null);
    setShowProductModal(false);
  };
  const handleAdvancedSearchClick = () => {
    navigate('/formalities/select')
  }
  return (
    <div id="home-main">

    </div >
  );
};
export default HomeMain;
